// extracted by mini-css-extract-plugin
export default {"section":"PhraseSection_section__25lyD","title":"PhraseSection_title__JvBSB","text":"PhraseSection_text__oQFtI"};